import Controller from "./sortableStations.controller";
import template from "./sortableStations.html";

const sortableStations = {
  template,
  controller: Controller,
  bindings: {
    selected: "<",
    items: "=",
    resource: "@",
    title: "@",
    name: "@",
    eventName: "<",
    sortable: "@",
    hideActions: "<",
    routeSchedules: "<",
  },
};

export default sortableStations;



// WEBPACK FOOTER //
// ./src/components/sortableStations/sortableStations.component.js